import {HttpHeaders} from "@angular/common/http";
import {CookieHelper} from "../app/helpers/CookieHelper";

export function getDefaultHeaders(): HttpHeaders {
  return new HttpHeaders().set('Authorization', 'Bearer ' + CookieHelper.getCookie("JWT"));
}

export const DEFAULT_HEADERS_PROVIDER = {
  provide: 'BASE_HEADERS',
  useFactory: getDefaultHeaders,
  deps: []
}
